module.exports = __webpack_public_path__ + "static/media/math-day-pos-logo-new.5c3f7e72.png";